import can from 'ember-can/helpers/can';
import RouteTemplate from 'ember-route-template';
import QuestionnairesList from 'garaje/components/visitors/questionnaires/list';

import type GlobalOverviewQuestionnairesIndexController from './controller';
import type { GlobalOverviewQuestionnairesIndexRouteModel } from './route';

interface Signature {
  Args: {
    controller: GlobalOverviewQuestionnairesIndexController;
    model: GlobalOverviewQuestionnairesIndexRouteModel;
  };
}

export default RouteTemplate<Signature>(
  <template>
    <QuestionnairesList
      @canCreateQuestionnaires={{can "create global questionnaires"}}
      @canDeleteQuestionnaires={{can "delete global questionnaires"}}
      @canUpdateQuestionnaires={{can "update global questionnaires"}}
      @createRoute="location-overview.questionnaires.create"
      @company={{@model.company}}
      @flows={{@model.flows}}
      @flowFilter={{@controller.flow}}
      @globalOnly={{true}}
      @showRoute="location-overview.questionnaires.show"
      @sort={{@controller.sort}}
      @titleFilter={{@controller.title}}
      @updateQueryParam={{@controller.updateQueryParam}}
    />
  </template>,
);
